/**
 * DDS Offers Page — Add to Cart via Shopify Cart API
 * Pattern reutilizat din dds-chatbot.js (linii 460-530)
 */
(function() {
  'use strict';

  /** Extrage innerHTML dintr-un string HTML folosind selector */
  function getInnerHTML(html, selector) {
    if (!html) return '';
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : doc.body.innerHTML;
  }

  /** Actualizează cart icon bubble (badge count) din section HTML */
  function updateCartBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubbles = document.querySelectorAll('[id="cart-icon-bubble"]');
    bubbles.forEach(function(bubble) {
      bubble.innerHTML =
        getInnerHTML(sections['cart-icon-bubble'], '#shopify-section-cart-icon-bubble') ||
        getInnerHTML(sections['cart-icon-bubble'], '.shopify-section') ||
        sections['cart-icon-bubble'];
    });
  }

  /** Actualizează și deschide cart drawer din section HTML */
  function updateAndOpenDrawer(sections) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !sections || !sections['cart-drawer']) return;

    var newDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var isCurrentlyEmpty = cartDrawer.classList.contains('is-empty');

    if (isCurrentlyEmpty) {
      // Coșul trece de la gol la primul produs — înlocuim tot
      var newInner = newDoc.querySelector('.drawer__inner');
      var oldInner = cartDrawer.querySelector('.drawer__inner');
      if (newInner && oldInner) {
        oldInner.innerHTML = newInner.innerHTML;
      }
      cartDrawer.classList.remove('is-empty');
    } else {
      // Coșul are deja produse — update selectiv
      var newItems = newDoc.querySelector('cart-drawer-items');
      var oldItems = cartDrawer.querySelector('cart-drawer-items');
      if (newItems && oldItems) {
        oldItems.innerHTML = newItems.innerHTML;
      }
      // Update footer (total, butoane)
      var newFooter = newDoc.querySelector('.drawer__footer');
      var oldFooter = cartDrawer.querySelector('.drawer__footer');
      if (newFooter && oldFooter) {
        oldFooter.innerHTML = newFooter.innerHTML;
      }
    }

    // Deschide drawer-ul
    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
    }
  }

  /** Handler principal — adaugă produsul în coș */
  async function handleAddToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    var originalText = btn.querySelector('.dds-ocard__btn-text').textContent;
    btn.disabled = true;
    btn.querySelector('.dds-ocard__btn-text').textContent = 'Se adaugă...';
    btn.classList.add('is-loading');

    try {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('sections', 'cart-icon-bubble,cart-drawer');
      formData.append('sections_url', window.location.pathname);

      var rootUrl = (window.Shopify && window.Shopify.routes)
        ? window.Shopify.routes.root : '/';

      var resp = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });

      if (!resp.ok) {
        var errText = await resp.text();
        throw new Error(errText);
      }

      var data = await resp.json();

      // Update UI
      updateCartBubble(data.sections);
      updateAndOpenDrawer(data.sections);

      // Feedback succes
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      btn.querySelector('.dds-ocard__btn-text').textContent = '✔ Adăugat!';

      setTimeout(function() {
        btn.classList.remove('is-success');
        btn.querySelector('.dds-ocard__btn-text').textContent = originalText;
        btn.disabled = false;
      }, 2000);

    } catch (err) {
      console.error('[DDS Offers] cart/add.js error:', err.message);
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');

      var isStock = err.message && err.message.includes('not available');
      btn.querySelector('.dds-ocard__btn-text').textContent =
        isStock ? 'Stoc epuizat' : 'Eroare, reîncearcă';

      setTimeout(function() {
        btn.classList.remove('is-error');
        btn.querySelector('.dds-ocard__btn-text').textContent = originalText;
        btn.disabled = false;
      }, 3000);
    }
  }

  // Interceptează form submit pentru AJAX (fallback = form nativ cu reload)
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.dds-ocard__form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.dds-offer-add-btn');
    if (btn) handleAddToCart(btn);
  });
})();
